<template>
  <!-- 勤務表 親コンポーネント -->
  <div id="roster">
    <CCard>
      <div v-if="!fromExternal">
        <CCardHeader>
          <h2>勤務表</h2>
        </CCardHeader>
        <CCardBody>
          <table class="table search-table">
            <tr>
              <th style="width: 100px">年月</th>
              <th style="width: 75px"></th>
              <th style="width: 50px"></th>
              <th></th>
            </tr>
            <tr>
              <td>
                <select
                  class="custom-select preika-control--year"
                  v-model="year"
                 
                >
                  <option
                    v-for="option in yearOption"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </td>
              <td>
                <select
                  class="custom-select preika-control--month"
                  v-model="month"
                 
                >
                  <option
                    v-for="option in monthOption"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </td>
              <td>業務分</td>
              <td>
                <save-button
                  :label="'表示'"
                  @click="callList"
                  />
              </td>
            </tr>
          </table>
        </CCardBody>
      </div>
      <template v-if="displayFlg">
        <div v-if="!fromExternal">
          <div class="roster-guide-grid">
            <CCard color="info" class="roster-guide-card text-white">
              <CCardHeader class="roster-guide-card__header">
                <strong>入力手順</strong>
              </CCardHeader>
              <CCardBody class="roster-guide-card__body">
                1.開始時刻、終了時刻、休憩、夜勤休憩に実績を入力<br/>
                （定時は候補表示です。過去日は「定時を反映」、当日はダッシュボード打刻を利用できます）<br/>
                2.勤怠1を選択<br/>
                勤怠1が「午前出勤」「午前有給」「午前代休」「午前特休」「早出出勤」「シフト」の場合は勤怠2（午後側）も選択<br/>
                勤怠1が「有給」「代休」「欠勤」「特休有給」「休日」の場合、時間欄は選択時に自動で空欄になります<br/>
                <a href="#" class="paid-rule-link" @click.prevent="openAttendanceHelp('1')">勤怠1の説明</a> /
                <a href="#" class="paid-rule-link" @click.prevent="openAttendanceHelp('2')">勤怠2の説明</a><br/>
                3.備考・作業内容を入力し、入力内容に不備がなければ「保存」ボタンを押下<br/>
              </CCardBody>
            </CCard>
            <RosterFileImport
              :year="year"
              :month="month"
              :month-day="monthDay"
              :start="start"
              :end="end"
              :rest="rest"
              :night-rest="nightRest"
              :attendance1="attendance1"
              :attendance2="attendance2"
              :remarks="remarks"
              :project-id="projectId"
              :project-options="projectOptions"
              :disabled="loading || statusBtn || bulkApplying"
              @apply="applyRosterFileImport"
            />
          </div>
        </div>
        <CCardHeader>
          <strong
            v-if="showYearMonth"
            style="font-size: 20px; font-weight: bold"
          >
            {{ selectYear }} 年 {{ selectMonth }} 月
            <span style="margin-left: 10px"></span>
            <span :style="statusColor(status[0])">【{{ getStatusLabel(status[0]) }}】</span>
          </strong>
        </CCardHeader>
        <CCardBody>
          <ValidationObserver ref="obs">
            <td v-if="errors.length">
              <div class="preika-form-message" v-for="error in errors" :key="error">
                {{ error }}
              </div>
            </td>
            <form
              class="edit-form"
              name="edit"
              action="/change"
              method="post"
              @submit.prevent="edit"
            >
              <div class="edit-form__group">
                <!--
                  **ボタンは説明のすぐ下・左。**

                  以前は flex の space-between で右端に離していた。
                  画面が広いほど離れるので、説明を読み終わった視線の先に
                  無い。2026-09-01、気づかない人が複数いたと報告があった。

                  「過去日の空欄は明示操作で定時を反映できます」と
                  書いてある、その直後に押すものが来る形にする。
                -->
                <div v-if="!fromExternal" class="roster-actual-guide">
                  <strong>定時は候補、時刻欄は実績です</strong>
                  <p>未来日は候補だけを表示し、当日はダッシュボード打刻を優先します。過去日の空欄は明示操作で定時を反映できます。</p>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm roster-actual-guide__action"
                    :disabled="loading || statusBtn"
                    @click="applyDefaultsToPast"
                  >
                    経過済みの空欄へ定時を反映
                  </button>
                </div>
                <CRow style="padding: 0px">
                  <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                      <thead>
                        <tr>
                          <th class="dayHeader"
                            style="
                              font-size: 11px;
                              width: 80px;
                              padding-bottom: 15px;
                            "
                          >
                            日付<br/>&nbsp;曜日
                          </th>
                          <th style="width: 120px">開始時刻</th>
                          <th style="width: 120px">終了時刻</th>
                          <th style="width: 120px"><span class="preika-th-note">5:00～22:00</span><br/>休憩</th>
                          <th style="width: 120px"><span class="preika-th-note">22:00～5:00</span><br/>夜勤休憩</th>
                          <th style="width: 120px">
                            勤怠1
                            <a
                              href="#"
                              class="help-icon help-icon-inline"
                              @click.prevent="openAttendance1Help"
                              aria-label="勤怠1の説明を表示"
                            >
                              ?
                            </a>
                          </th>
                          <th style="width: 120px">
                            勤怠2
                            <a
                              href="#"
                              class="help-icon help-icon-inline"
                              @click.prevent="openAttendance2Help"
                              aria-label="勤怠2の説明を表示"
                            >
                              ?
                            </a>
                          </th>
                          <th style="width: 300px">備考・作業内容</th>
                          <th style="width: 150px">
                            <select
                              class="custom-select preika-control--reference"
                             
                              v-model="bulkProjectId"
                              @change="applyBulkProject"
                              :disabled="bulkApplying || loading"
                            >
                              <option disabled value="">【一括変更】</option>
                              <option
                                v-for="opt in projectOptions"
                                :key="opt.id"
                                :value="opt.id"
                              >
                                {{ opt.name }}<template v-if="opt.external">（現在所属外）</template>
                              </option>
                            </select>
                            プロジェクト名
                          </th>
                          <th style="width: 80px">作業</th>
                          <th style="width: 80px">時間外</th>
                          <th style="width: 80px">夜勤<br/></th>
                          <th style="width: 80px">法定休日</th>
                          <th style="width: 80px">控除</th>
                        </tr>
                        <!-- <input type="hidden" :value="setDay"> -->
                        <!-- <input type="hidden" :value="holiday"> -->
                        <input type="hidden" :value="endSetting" />
                      </thead>
                      <tbody
                        v-for="(day, index) in monthDay"
                        :key="index"
                        :class="getDayClass(day,attendance1[index])"
                      >
                        <tr>
                          <td style="width: 5%">
                            <label class="dayLabel">{{ monthDay[index].replace(' (', '\n(') }}</label>
                            <span v-if="isFutureIndex(index)" class="roster-row-state">予定</span>
                            <button
                              v-else-if="canApplyDefaultAt(index)"
                              type="button"
                              class="roster-default-button"
                              @click="applyDefaultAt(index)"
                            >定時を反映</button>
                          </td>
                          <td style="width: 0%">
                            <ValidationProvider
                              :name="[index + 1] + '日の開始時刻'"
                              rules=""
                              v-slot="provider"
                            >
                              <CInput class="preika-control-frame--time"
                                style="margin-bottom: 3px"
                                type="time"
                                maxlength="5"
                                v-model="start[index]"
                                :placeholder="schedulePlaceholder(startBasic[index])"
                                :disabled="isFutureIndex(index)"
                                :tabindex="[index] + 1"
                                @change="autoRestTime(index)"
                              />
                              <small
                                v-if="!start[index] && startBasic[index]"
                                class="roster-time-candidate"
                              >候補 {{ startBasic[index] }}</small>
                              <p class="roster-field-error">
                                {{ provider.errors[0] }}
                              </p>
                            </ValidationProvider>
                          </td>
                          <td style="width: 0%">
                            <ValidationProvider
                              :name="[index + 1] + '日の終了時刻'"
                              rules=""
                              v-slot="provider"
                            >
                              <CInput class="preika-control-frame--time"
                                style="margin-bottom: 3px"
                                type="time"
                                maxlength="5"
                                v-model="end[index]"
                                :placeholder="schedulePlaceholder(endBasic[index])"
                                :disabled="isFutureIndex(index)"
                                :tabindex="[index] + 2"
                                @change="autoRestTime(index)"
                              />
                              <small
                                v-if="!end[index] && endBasic[index]"
                                class="roster-time-candidate"
                              >候補 {{ endBasic[index] }}</small>
                              <p class="roster-field-error">
                                {{ provider.errors[0] }}
                              </p>
                            </ValidationProvider>
                          </td>
                          <td style="width: 0%">
                            <RestInput
                              :rest="rest[index]"
                              :index="index"
                              :post-buffer="postBuffer[index]"
                              :breakBasic="breakBasic[index]"
                              :flg="postWorkBreakFlg[index]"
                              :is-holiday="isHoliday(index)"
                              :actual-end="end[index]"
                              :end-basic="endBasic[index]"
                              :tabindex="index + 3"
                              :label="(index + 1) + '日の休憩'"
                              :disabled="isFutureIndex(index)"
                              :placeholder="schedulePlaceholder(breakBasic[index])"
                              @update-rest="onUpdateRest"
                            />
                          </td>
                          <td style="width: 0%">
                            <ValidationProvider
                              :name="[index + 1] + '日の夜勤休憩'"
                              rules=""
                              v-slot="provider"
                            >
                              <CInput class="preika-control-frame--time"
                                style="margin-bottom: 3px"
                                type="time"
                                maxlength="5"
                                v-model="nightRest[index]"
                                placeholder="候補 00:00"
                                :disabled="isFutureIndex(index)"
                                :tabindex="[index] + 4"
                              />
                              <small
                                v-if="!nightRest[index]"
                                class="roster-time-candidate"
                              >候補 00:00</small>
                              <p class="roster-field-error">
                                {{ provider.errors[0] }}
                              </p>
                            </ValidationProvider>
                          </td>
                          <td>
                            <ValidationProvider
                              :name="[index + 1] + '日の勤怠1'"
                              rules="select"
                              v-slot="provider"
                            >
                              <select
                                style="margin-bottom: 3px"
                                class="custom-select preika-control--choice"
                                v-model="attendance1[index]"
                                :tabindex="[index] + 4"
                                @change="autoTime(index)"
                              >
                                <option value></option>
                                <option
                                  v-for="option in visibleOptionsAt(index)"
                                  :value="option.id"
                                  :key="option.id"
                                >
                                  {{ option.name }}
                                </option>
                              </select>
                              <p class="roster-field-error">
                                {{ provider.errors[0] }}
                              </p>
                            </ValidationProvider>
                          </td>
                          <td>
                            <ValidationProvider
                              :name="[index + 1] + '日の勤怠2'"
                              :rules="{ select }"
                              v-slot="provider"
                            >
                              <select
                                style="margin-bottom: 3px"
                                class="custom-select preika-control--choice"
                                v-model="attendance2[index]"
                                v-bind:disabled="devide[index]"
                                :tabindex="[index] + 5"
                              >
                                <option disabled value>未選択</option>
                                <option
                                  v-for="option2 in visibleOptions2At(index)"
                                  :value="option2.id"
                                  :key="option2.id"
                                >
                                  {{ option2.name }}
                                </option>
                              </select>
                              <p class="roster-field-error">
                                {{ provider.errors[0] }}
                              </p>
                            </ValidationProvider>
                            <!-- 勤怠2の入力可否を記載 -->
                            <input type="hidden" :value="afternoon" />
                          </td>
                          <td>
                            <ValidationProvider
                              :name="[index + 1] + '日の備考・作業内容'"
                              rules=""
                              v-slot="provider"
                            >
                              <CInput
                                style="margin-bottom: 3px; width: 200px;"
                                type="text"
                                v-model="remarks[index]"
                                :tabindex="[index] + 6"
                              />
                              <p class="roster-field-error">
                                {{ provider.errors[0] }}
                              </p>
                            </ValidationProvider>
                          </td>
                          <!-- プロジェクト -->
                          <td>
                            <select
                              class="custom-select preika-control--reference"
                              style="margin-bottom: 3px"
                              v-model="projectId[index]"
                              @change="onChangeProject(index)"
                            >
                              <option
                                v-for="opt in projectOptions"
                                :key="opt.id"
                                :value="opt.id"
                              >
                                {{ opt.name }}<template v-if="opt.external">（現在所属外）</template>
                              </option>
                            </select>
                          </td>
                          <!-- 勤務時間のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <DailyWork
                              :monthDay="monthDay"
                              :index="index"
                              :total="dailyWorkResult"
                            ></DailyWork>
                          </td>
                          <!-- 時間外のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <OverTime
                              :dailyWorkResult="dailyWorkResult"
                              :workTimeUnit="workTimeUnit"
                              :workBasic="workBasic"
                              :index="index"
                              :attendance1="attendance1"
                              :attendance2="attendance2"
                              @updateOverTime="handleOvertimeUpdate"
                            ></OverTime>
                          </td>
                          <!-- 夜勤のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <NightWork
                              :monthDay="monthDay"
                              :start="start"
                              :end="send_end"
                              :nightRest="nightRest"
                              :attendance1="attendance1"
                              :earlyMorningShiftBasic="earlyMorningShiftBasic"
                              :lateNightShiftBasic="lateNightShiftBasic"
                              :midnightBasic="midnightBasic"
                              :nightShiftTimes="nightShiftTimes"
                              :dateChangeShiftTimes="dateChangeShiftTimes"
                              :index="index"
                              @updateNightTime="handleNightTimeUpdate"
                            ></NightWork>
                          </td>
                          <!-- 休日のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <HolidayWork
                              :monthDay="monthDay"
                              :start="start"
                              :end="send_end"
                              :rest="rest"
                              :attendance1="attendance1"
                              :index="index"
                              @updateHolidayWork="handleHolydayWorkUpdate"
                            ></HolidayWork>
                          </td>
                          <!-- 控除のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <Deduction
                              :monthDay="monthDay"
                              :startBasic="startBasic"
                              :endBasic="endBasic"
                              :breakBasic="breakBasic"
                              :start="start"
                              :end="send_end"
                              :rest="rest"
                              :attendance1="attendance1"
                              :attendance2="attendance2"
                              :workBasic="workBasic"
                              :index="index"
                              @updateDeduct="handleDeductionUpdate"
                            ></Deduction>
                          </td>
                        </tr>
                      </tbody>
                      <!-- DBから取得したID -->
                      <!-- <input v-for="(n, index) in monthDay" :key="index" type="hidden" v-model="id[index]" name="id" readonly> -->
                      <!-- 送信用としてTime型に変換した入力値の配列 -->
                      <input type="hidden" :value="sendStart" readonly />
                      <input type="hidden" :value="sendEnd" readonly />
                      <input type="hidden" :value="sendBreak" readonly />
                    </table>
                  </div>
                </CRow>
              </div>
            </form>
          </ValidationObserver>
        </CCardBody>
        <CCardBody>
          <CRow v-if="success3.length">
            <ul>
              <li
                style="color: blue"
                v-for="success in success3"
                :key="success"
              >
                {{ "※" + success }}
              </li>
            </ul>
          </CRow>
          <!-- 累計時間のコンポーネント呼出 -->
          <MonthlyData
            key="keyChild"
            :validateBeforeSave="validateBeforeSave"
            :today="today"
            :fromExternal="fromExternal"
            :monthDay="monthDay"
            :outBasic="outBasic"
            :startBasic="startBasic"
            :endBasic="endBasic"
            :breakBasic="breakBasic"
            :earlyMorningShiftBasic="earlyMorningShiftBasic"
            :lateNightShiftBasic="lateNightShiftBasic"
            :midnightBasic="midnightBasic"
            :nightShiftTimes="nightShiftTimes"
            :dateChangeShiftTimes="dateChangeShiftTimes"
            :start="start"
            :end="send_end"
            :rest="rest"
            :nightRest="nightRest"
            :attendance1="attendance1"
            :attendance2="attendance2"
            :remarks="remarks"
            :year="year"
            :month="month"
            :totalTime="dailyWorkResult"
            :overTime="overTimeData"
            :nightWork="nightTimeData"
            :holiday="holiDayWorkData"
            :deduct="deductionData"
            :statusBtn="statusBtn || bulkApplying"
            :userId="user_id"
            :paid="paid"
            :paidDaysUsed="paidDaysUsed"
            :paidDaysAdd="paidDaysAdd"
            :instead="instead"
            :get_paid="get_paid"
            :addInstead="addInstead"
            :items="items"
            :projectId="projectId"
            :daily-version="dailyVersion"
            :base-time-min="baseTimeMin"
            :base-time-max="baseTimeMax"
            @updateAllData="callList"
          ></MonthlyData>
        </CCardBody>
      </template>
    </CCard>
    <CModal :show.sync="attendanceHelpOpen" size="lg" centered>
      <CModalHeader :close-button="true">勤怠の説明</CModalHeader>

      <CModalBody>
        <div v-if="attendanceHelpKind === '1'">
          <div style="font-weight: bold; margin-bottom: 8px;">勤怠1（その日の区分：終日／午前側）</div>
          <div>勤怠1は、その日の扱い（終日、または午前側の区分）を選択します。</div>
          <ul style="margin-top: 8px;">
            <li><b>「常勤」</b>：通常勤務（開始/終了/休憩/夜勤休憩を入力）</li>
            <li><b>「午前出勤」「午前有給」「午前代休」「午前特休」「早出出勤」</b>：午前側の区分。午後側は勤怠2で指定します</li>
            <li><b>「シフト」</b>：始業時間の変更がある日（選択すると勤怠2は自動で「シフト」になります）</li>
            <li><b>「有給」「代休」「欠勤」「特休有給」「休日」</b>：選択すると時間入力欄は自動で空欄になります</li>
          </ul>
          <div style="margin-top: 8px;">※ 勤怠2が選択可能なときだけ、勤怠2のプルダウンが有効になります。</div>
        </div>

        <div v-else>
          <div style="font-weight: bold; margin-bottom: 8px;">勤怠2（午後側／終業側の区分）</div>
          <div>勤怠2は、午前側が特殊な日の「午後側（または終業側）」の扱いを指定します。</div>
          <ul style="margin-top: 8px;">
            <li><b>「午後出勤」</b>：午後は通常出勤</li>
            <li><b>「午後有給」</b>：午後が有給</li>
            <li><b>「午後特休」</b>：午後が特休</li>
            <li><b>「午後代休」</b>：午後が代休</li>
            <li><b>「シフト」</b>：終業時間の変更がある日（勤怠1が「シフト」のときは自動設定）</li>
          </ul>
          <div style="margin-top: 8px;">
            ※ 勤怠1が「午前出勤」「午前有給」「午前代休」「午前特休」「早出出勤」「シフト」のときのみ選択できます。
          </div>
        </div>
      </CModalBody>
      <template #footer>
        <button class="btn btn-secondary" @click="closeAttendanceHelp">閉じる</button>
      </template>
    </CModal>
    <div v-if="globalLoading" class="loading-overlay" aria-live="polite" aria-busy="true">
      <CSpinner color="primary" style="width: 3rem; height: 3rem;" />
    </div>
  </div>
</template>

<script>
import MonthlyData from "./MonthlyData";
import DailyWork from "./DailyWork";
import Deduction from "./Deduction";
import HolidayWork from "./HolidayWork";
import NightWork from "./NightWork";
import OverTime from "./OverTime";
import RestInput from "./RestInput";
import axios from "axios";
import moment from "moment";
import ConstList from "./../ConstList";
import SubmissionConst from "./../submission_approval/ConstList";
import RosterFileImport from './RosterFileImport';
import SaveButton from '../common/SaveButton';
import { normalizeTimeValue } from '../utils/timeValue';
import {
  canApplyScheduledTimes,
  isFutureRosterIndex,
  isPastRosterIndex,
  rosterDateKey,
} from '../utils/rosterActualPolicy';
import { getCachedAccessContext } from '../services/accessContext';
export default {
  name: "Roster",
  components: {
    MonthlyData,
    DailyWork,
    Deduction,
    HolidayWork,
    NightWork,
    OverTime,
    RosterFileImport,
    RestInput,
    SaveButton,
  },
  props: {
    externalUserId: [String, Number],
    externalYear: Number,
    externalMonth: Number,
    externalUserName: String,
    fromExternal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      user_id: "",
      user_name: "",
      project: "",
      projectList: [],
      outBasic: "05:00",
      startBasic: [],
      endBasic: [],
      breakBasic: [],
      preBuffer: [],
      postBuffer: [],
      workTimeUnit: [],
      workBasic: [],
      postWorkBreakFlg: [], 
      earlyMorningShiftBasic: "5:00",
      lateNightShiftBasic: "22:00",
      midnightBasic: "24:00",
      nightShiftTimes: "05:00",
      dateChangeShiftTimes: "02:00",
      monthDay: [],
      computedOvertime: [], // ここで計算した時間外労働のデータを保持
      id: [],
      dailyVersion: [],
      date: [],
      hour: [],
      minutes: [],
      start: [],
      end: [],
      rest: [],
      nightRest: [],
      project_name: [],
      projectId: [],            // 日別の project_id を保持
      projectOptions: [],       // [{id, name, external?: true}]（所属外は external 表示のみ）
      attendance1: [],
      attendance2: [],
      options: [
        {
          id: ConstList.FULLTIME,
          name: "常勤",
          description: "規定勤務時間で勤務する日",
        },

        {
          id: ConstList.HOLIDAY,
          name: "休日",
          description: "振替休日または休日出勤として扱う日",
        },
        {
          id: ConstList.SHIFT,
          name: "シフト",
          description: "始業時刻を変更する日",
        },
        {
          id: ConstList.MORNING_WORK,
          name: "午前出勤",
          description: "午後側を半休として設定する日",
        },
        {
          id: ConstList.EARLY_MORNING,
          name: "早出出勤",
          description: "定時前から勤務する日",
        },
        {
          id: ConstList.PAID,
          name: "有給",
        },
        {
          id: ConstList.MORNING_PAID,
          name: "午前有給",
        },
        {
          id: ConstList.SUBSTITUTE,
          name: "代休",
        },
        {
          id: ConstList.MORNING_SUBSTITUTE,
          name: "午前代休",
        },
        {
          id: ConstList.DEDUCTION,
          name: "欠勤",
        },
        {
          id: ConstList.MORNING_DEDUCTION,
          name: "午前欠勤",
          description: "午前だけ来なかった日。午後側は勤怠2で指定します",
        },
        {
          id: ConstList.SPECIAL_HOLIDAY,
          name: "特休有給",
        },
        {
          id: ConstList.MORNING_SPECIAL_HOLIDAY,
          name: "午前特休",
        },
      ],
      options2: [
        {
          id: ConstList.AFTERNOON_WORK,
          name: "午後出勤",
          description: "午前側を半休として設定する日",
        },
        {
          id: ConstList.SHIFT,
          name: "シフト",
          description: "終業時刻を変更する日",
        },
        {
          id: ConstList.AFTERNOON_PAID,
          name: "午後有給",
        },
        {
          id: ConstList.AFTERNOON_SUBSTITUTE,
          name: "午後代休",
        },
        {
          // **勤怠1の 16（早出出勤）と同じ番号だが、列が違う。**
          id: ConstList.AFTERNOON_DEDUCTION,
          name: "午後欠勤",
        },
        {
          id: ConstList.AFTERNOON_SPECIAL_HOLIDAY,
          name: "午後特休",
        },
      ],
      remarks: [],
      devide: [],
      items: [],
      baseTimeMin: [],
      baseTimeMax: [],
      start_time: [],
      end_time: [],
      break_time: [],
      today: [],
      success3: [],
      status: [],
      errors: [],
      displayFlg: false,
      id2_disable: false,
      send_end: [],
      total: [],
      showYearMonth: false,
      // 承認状態による登録ボタンの非活性化
      statusBtn: false,
      loading: false,
      bulkProjectId: "",// 一括変更用（初期は空欄）
      bulkApplying: false, 
      attendanceHelpOpen: false,
      attendanceHelpKind: "1",
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
  },
  methods: {
    /**
     * 保存の前に、入力欄の検証を通す。
     *
     * **通らなければ false を返して保存を止める。**
     * いままで ValidationObserver は置いてあるだけで誰も見ておらず、
     * 開始時刻を空のまま保存できていた。
     *
     * 最初に見つかった欄まで画面を送る——31行ある表で
     * 「どこかが赤い」とだけ言われても探せない。
     */
    async validateBeforeSave () {
      const obs = this.$refs.obs
      if (!obs) return true

      const ok = await obs.validate()
      if (ok) return true

      await this.$nextTick()
      const first = this.$el.querySelector('.roster-field-error')
      if (first && first.scrollIntoView) {
        first.scrollIntoView({ block: 'center' })
      }
      return false
    },

    // $setのタイミング次第では古い値を子コンポーネントに渡す可能性があるため、遅延を入れる
    // Vue2の仕様で、配列の中身が変わっても「参照が同じ」だとcomputedのメソッドが発火しないため、
    // すべての要素を新しい配列で再代入
    handleOvertimeUpdate({ index, value }) {
      this.$nextTick(() => {
        this.overTimeData = [...this.overTimeData];
      });
      this.$set(this.overTimeData, index, value);
    },
    handleNightTimeUpdate({ nights, index, value }) {
      this.$nextTick(() => {
        this.nightTimeData = [...nights];
      });
      this.$set(this.nightTimeData, index, value);
    },
    handleHolydayWorkUpdate({ index, value }) {
      this.$nextTick(() => {
        this.holiDayWorkData = [...this.holiDayWorkData];
      });
      this.$set(this.holiDayWorkData, index, value);
    },
    handleDeductionUpdate({ index, value }) {
      this.$nextTick(() => {
        this.deductionData = [...this.deductionData];
      });
      this.$set(this.deductionData, index, value);
    },
    isHoliday(index) {
      if (this.attendance1[index] === ConstList.HOLIDAY
          || this.attendance1[index] === ConstList.PAID
          || this.attendance1[index] === ConstList.SUBSTITUTE
          || this.attendance1[index] === ConstList.DEDUCTION) {
            //休日や有給休暇、代休、欠勤の場合、trueを返す
        return true;
      } else {
        return false;
      }
    },

    onUpdateRest({ index, value }) {
      this.$set(this.rest, index, value);
    },

    // DBから一覧呼出メソッド
    callList: function () {
      this.loading = true;
      this.monthDay = [];
      this.id = [];
      this.dailyVersion = [];
      this.date = [];
      this.total = [];
      this.start = [];
      this.end = [];
      this.rest = [];
      this.nightRest = [];
      this.project_name = [];
      this.projectOptions = []
      this.attendance1 = [];
      this.attendance2 = [];
      this.remarks = [];
      this.dailyWork = [];
      this.overTimeData = [];
      this.nightTimeData = [];
      this.holiDayWorkData = [];
      this.deductionData = [];
      this.preBuffer = [];
      this.postBuffer = [];
      this.postWorkBreakFlg = [];
      this.workTimeUnit = [];
      this.workBasic = [];
      (this.status = []), (this.errors = []), (this.displayFlg = false);
      this.statusBtn = false;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      // 本人用の /select は対象者をログインセッションで確定するため、
      // userId を送っても無視される（バックエンドの引数名は ignoredUserId）。
      // 管理者が他スタッフの勤務表を開く場合は、対象者を受け取る
      // /admin/rosterSelect を使わないと自分自身の勤務表が表示されてしまう。
      const rosterRequest = this.fromExternal
        ? axios.get(process.env.VUE_APP_API_ORIGIN + "/admin/rosterSelect", {
            params: {
              user_id: this.user_id,
              year: this.year,
              month: this.month,
            },
          })
        : axios.get(process.env.VUE_APP_API_ORIGIN + "/select", {
            params: {
              year: this.year,
              month: this.month,
            },
          });
      rosterRequest
        .then((response) => {
          this.item = [];
          this.monthDay = [];
          this.items = response.data;
          this.displayFlg = true;
          this.showYearMonth = true;
          this.selectYear = this.year;
          this.selectMonth = this.month;
          const paddedMonth = String(this.month).padStart(2, "0"); // "01"〜"12"

          const startDate = moment(`${this.year}-${paddedMonth}-01`)
            .startOf("month")
            .locale("ja", {
              weekdays: ["日", "月", "火", "水", "木", "金", "土"],
            });

          const endDate = moment(`${this.year}-${paddedMonth}-01`)
            .endOf("month")
            .locale("ja", {
              weekdays: ["日", "月", "火", "水", "木", "金", "土"],
            });

          while (startDate.unix() <= endDate.unix()) {
            this.monthDay.push(startDate.format("D日 (dd)"));
            startDate.add(1, "days");
          }

          // ユーザID取得
          if (this.items?.length && !this.user_id) {
            this.user_id = this.items[0][ConstList.USER_ID];
          }

          // ユーザー所属プロジェクト一覧を取得。
          // /projects はログイン利用者本人の所属を返すため、管理者が他スタッフを
          // 開いている場合は使わない（対象者の所属を返すAPIは存在しない）。
          // 外部モードでは勤務表の行に現れるプロジェクトから選択肢を組み立てる。
          return (this.fromExternal
            ? Promise.resolve({ data: [] })
            : axios.get(process.env.VUE_APP_API_ORIGIN + "/projects", {}))
            .then(({ data: projList }) => {
            // 1) 所属（数値IDで正規化）
            const belong = (projList || []).map(p => ({ id: +p.id, name: p.name }));
            const belongIdSet = new Set(belong.map(p => p.id));

            // 2) 履歴に出てくるプロジェクト（存在するIDだけ拾う）
            const fromItems = (this.items || [])
              .map(r => {
                const id = r[ConstList.PROJECT_ID];
                if (id === null || id === undefined || isNaN(+id)) return null;
                return { id: +id, name: r[ConstList.PROJECT_NAME] || `(ID:${+id})` };
              })
              .filter(Boolean);

            // 3) 所属＋履歴をIDでユニーク化し、所属外には external フラグ
            const map = new Map();
            [...belong, ...fromItems].forEach(p => {
              if (!map.has(p.id)) {
                map.set(p.id, {
                  id: p.id,
                  name: p.name,
                  external: !belongIdSet.has(p.id),
                });
              }
            });
            this.projectOptions = Array.from(map.values());

            // 4) 各日の選択値を一気に作る（saved がなければ先頭を既定）
            const defaultId = this.projectOptions[0]?.id ?? null;
            this.projectId = (this.items || []).map(r => {
              const saved = r[ConstList.PROJECT_ID];
              return (saved !== null && saved !== undefined && !isNaN(+saved))
                ? +saved
                : defaultId;
            });
            
            for (let i = 0; i < this.items.length; i++) {
              const days = moment(this.items[i][ConstList.DATE]);
              days.format("YYYY-MM-DD");
              const rowId = this.items[i][ConstList.ID];
              const suggestionOnly = rowId == null || this.isFutureIndex(i);
              this.id.splice(i, 1, rowId);
              this.dailyVersion.splice(i, 1, this.items[i][ConstList.DAILY_VERSION] ?? null);
              this.user_id = this.items[i][ConstList.USER_ID];
              this.start.splice(i, 1, suggestionOnly ? '' : (this.items[i][ConstList.START_TIME] || ''));
              this.end.splice(i, 1, suggestionOnly ? '' : (this.items[i][ConstList.END_TIME] || ''));
              this.rest.splice(i, 1, suggestionOnly ? '' : (this.items[i][ConstList.BREAK_TIME] || ''));
              this.nightRest.splice(
                i,
                1,
                suggestionOnly
                  ? ''
                  : normalizeTimeValue(this.items[i][ConstList.NIGHT_REST], '')
              );
              this.baseTimeMin.splice(i, 1, this.items[i][ConstList.BASE_TIME_MIN] ?? null);
              this.baseTimeMax.splice(i, 1, this.items[i][ConstList.BASE_TIME_MAX] ?? null);
              this.attendance1.splice(i, 1, this.items[i][ConstList.ATTENDANCE1]);
              this.attendance2.splice(i, 1, this.items[i][ConstList.ATTENDANCE2]);
              this.remarks.splice(i, 1, this.items[i][ConstList.REMARKS]);
              this.startBasic.splice(i, 1, this.items[i][ConstList.BASIC_START_TIME]);
              this.endBasic.splice(i, 1, this.items[i][ConstList.BASIC_END_TIME]);
              this.breakBasic.splice( i, 1, this.items[i][ConstList.BASIC_BREAK_TIME]);
              this.preBuffer.splice(i, 1, this.items[i][ConstList.PRE_BUFFER] || "");
              this.postBuffer.splice(i, 1, this.items[i][ConstList.POST_BUFFER] || "");
              this.workTimeUnit.splice(i, 1, this.items[i][ConstList.WORK_TIME_UNIT] || "");
              this.workBasic.splice(i, 1, this.items[i][ConstList.WORK_BASIC] || "");
              this.postWorkBreakFlg.splice(i, 1, !!this.items[i][ConstList.POST_WORK_BREAK_FLG]);
              this.status.splice(i, 1, this.items[i][ConstList.STATUS]);

              const status = this.items[i][ConstList.STATUS];

              if (status === ConstList.APPROVAL) {
                // 承認済 → t_monthly
                this.paid = this.items[i][ConstList.PAID_PRE] ?? "0";
                this.paidDaysUsed = this.items[i][ConstList.PAID_DAYS_USED] ?? "0";
                this.paidDaysAdd = this.items[i][ConstList.PAID_DAYS_ADD] ?? "0";
                this.get_paid = this.items[i][ConstList.PAID_ADDED] ?? "0";
                this.instead = this.items[i][ConstList.SUBSTITUTE_PRE] ?? "0";
                this.addInstead = this.items[i][ConstList.SUBSTITUTE_ADDED] ?? "0";
              } else {
                // 差戻・未申請・初回保存前 → t_user 由来
                this.paid = this.items[i][ConstList.PAID_PRE];
                this.paidDaysUsed = this.items[i][ConstList.PAID_DAYS_USED];
                this.paidDaysAdd = this.items[i][ConstList.PAID_DAYS_ADD];
                this.get_paid = this.items[i][ConstList.PAID_ADDED];
                this.instead = this.items[i][ConstList.SUBSTITUTE_PRE];
                this.addInstead = this.items[i][ConstList.SUBSTITUTE_ADDED];
              }

              // nullを空文字に統一
              this.dailyWork.splice(i, 1, this.items[i][ConstList.WORK_TIME] || "");
              this.overTimeData.splice(i, 1, this.items[i][ConstList.OVER_TIME] || "");
              this.nightTimeData.splice(i, 1, this.items[i][ConstList.NIGHT_WORK] || "");
              this.holiDayWorkData.splice(i, 1, this.items[i][ConstList.HOLIDAY] || "");
              this.deductionData.splice(i, 1, this.items[i][ConstList.DEDUCT] || "");
            }

            this.$nextTick(() => {
              this.$forceUpdate();
            });

            if (this.status[0] == ConstList.APPROVAL_PENDING) {
              this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_PENDING);
              this.statusBtn = true;
            }

            // 承認済み状態はメッセージ表示とボタン非活性化
            if (this.status[0] == ConstList.APPROVAL) {
              this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_APPROVAL);
              this.statusBtn = true;
            }
            // 初回表示（新規月含む）でも“その日のプロジェクト基準”で計算できるよう、日別に基準を流し込む
            return this.hydrateDailyBasicsByProject();
          })
        })
        .catch((error) => {
          this.displayFlg = false;
          axios
          .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
          .then(()=> {
              alert(ConstList.SYSTEM_ERROR);
            })
          .catch(()=> {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rosterDateKey(index) {
      return rosterDateKey(this.year, this.month, index);
    },
    isFutureIndex(index) {
      return isFutureRosterIndex({
        year: this.year,
        month: this.month,
        index,
        todayKey: moment().format("YYYY-MM-DD"),
      });
    },
    isPastIndex(index) {
      return isPastRosterIndex({
        year: this.year,
        month: this.month,
        index,
        todayKey: moment().format("YYYY-MM-DD"),
      });
    },
    schedulePlaceholder(value) {
      return value ? `候補 ${value}` : "実績未入力";
    },
    canApplyDefaultAt(index) {
      return canApplyScheduledTimes({
        year: this.year,
        month: this.month,
        index,
        todayKey: moment().format("YYYY-MM-DD"),
        attendance: this.attendance1[index],
        fullTimeId: ConstList.FULLTIME,
        start: this.start[index],
        end: this.end[index],
        startBasic: this.startBasic[index],
        endBasic: this.endBasic[index],
      });
    },
    applyDefaultAt(index) {
      if (!this.canApplyDefaultAt(index)) return false;
      this.$set(this.start, index, this.startBasic[index] || "");
      this.$set(this.end, index, this.endBasic[index] || "");
      this.$set(this.rest, index, this.breakBasic[index] || "");
      this.$set(this.nightRest, index, "00:00");
      this.autoRestTime(index);
      return true;
    },
    applyDefaultsToPast() {
      const candidates = this.monthDay
        .map((_, index) => index)
        .filter(index => this.isPastIndex(index) && this.canApplyDefaultAt(index));
      if (!candidates.length) {
        alert("経過済みの日に、定時を反映できる空欄はありません。");
        return;
      }
      if (!window.confirm(
        `${candidates.length}日分の空欄へプロジェクト定時を実績として反映します。よろしいですか？`
      )) return;
      candidates.forEach(index => this.applyDefaultAt(index));
    },
    getDayClass(day,attendance) {
      const dayOfWeek = day.substring(
        day.lastIndexOf("(") + 1,
        day.lastIndexOf(")")
      );
      if (dayOfWeek === "土") return {blue: dayOfWeek === "土"};
      else if (attendance === 5) return {red: attendance === 5};
    },
    /*
     * 勤怠1の選択肢。半休を使わない会社では午前有給・午前代休・
     * 午前特休・午前欠勤を出さない。
     *
     * **午前欠勤も隠す。**休暇ではないが、このフラグは「休暇制度」では
     * なく半日という単位を扱うかを決めている。残すと、勤務表では
     * 選べるのに休暇申請の時間帯が「終日」だけで午前の欠勤申請を
     * 出せず、整合性の検査で**その月の勤務表を提出できなくなる。**
     * 実機で詰みを確認した。
     *
     * 半休を使わない会社で午前だけ来なかった日は、実際の出退勤時刻を
     * 入れて**遅刻**として控除する。控除額は半日欠勤と同じ4時間。
     *
     * **その行に既に入っている値は残す。**フラグを切ったあとに過去の
     * 勤務表を開いたとき、選択肢から消すと画面が空欄になり、
     * そのまま保存すると勤怠区分が消える。実機で見つけた。
     */
    visibleOptionsAt: function (index) {
      if (this.usesHalfDayLeave) return this.options;
      const 隠す = [
        ConstList.MORNING_PAID,
        ConstList.MORNING_SUBSTITUTE,
        ConstList.MORNING_SPECIAL_HOLIDAY,
        ConstList.MORNING_DEDUCTION
      ];
      const いまの値 = this.attendance1[index];
      return this.options.filter(
        o => !隠す.includes(o.id) || o.id === いまの値
      );
    },
    /**
     * 午前の休みと、それに対応する午後の休み。
     *
     * <p><b>同じ種類を午前と午後の両方には選ばせない。</b>1日まるごと
     * 休むなら終日の区分（有給・代休・特休・欠勤）を選ぶ。</p>
     *
     * <p>種類が違う組み合わせは残す。午前有給＋午後代休 は、有給が
     * 0.5日しか残っていない人が実際に取る形で、終日では表せない。</p>
     */
    午後の同じ種類: function (勤怠1) {
      if (勤怠1 === ConstList.MORNING_PAID) {
        return ConstList.AFTERNOON_PAID;
      }
      if (勤怠1 === ConstList.MORNING_SUBSTITUTE) {
        return ConstList.AFTERNOON_SUBSTITUTE;
      }
      if (勤怠1 === ConstList.MORNING_SPECIAL_HOLIDAY) {
        return ConstList.AFTERNOON_SPECIAL_HOLIDAY;
      }
      if (勤怠1 === ConstList.MORNING_DEDUCTION) {
        return ConstList.AFTERNOON_DEDUCTION;
      }
      return null;
    },
    /**
     * 勤怠2の選択肢。
     *
     * <p>半休を使わない会社では午後の半休と午後欠勤を出さない。
     * 午後出勤とシフトは残す。</p>
     *
     * <p><b>半休を使う会社でも、勤怠1と同じ種類の午後は出さない。</b>
     * 勤怠1を選ぶまで勤怠2は触れないが、触れるようになったあとの
     * 選択肢は絞られていなかった。午前欠勤＋午後欠勤を選べてしまい、
     * 1日休んでいるのに控除が半日ぶんしか出なかった。
     * 有給・代休・特休も同じ形。</p>
     *
     * <p><b>その行にいま入っている値は残す。</b>選択肢から消すと、
     * 過去の勤務表を開いたとき画面が空欄になり、そのまま保存すると
     * 勤怠区分が消える。この製品で実際に踏んでいる。</p>
     */
    visibleOptions2At: function (index) {
      const 隠す = [];
      if (!this.usesHalfDayLeave) {
        隠す.push(
          ConstList.AFTERNOON_PAID,
          ConstList.AFTERNOON_SUBSTITUTE,
          ConstList.AFTERNOON_SPECIAL_HOLIDAY,
          ConstList.AFTERNOON_DEDUCTION
        );
      }
      const 同じ種類 = this.午後の同じ種類(this.attendance1[index]);
      if (同じ種類 !== null) {
        隠す.push(同じ種類);
      }
      if (!隠す.length) return this.options2;
      const いまの値 = this.attendance2[index];
      return this.options2.filter(
        o => !隠す.includes(o.id) || o.id === いまの値
      );
    },
    // 時間の自動入力
    autoTime: function (index) {
      const id1 = this.attendance1[index];

      // 勤怠1=シフト → 勤怠2も自動でシフト
      if (id1 === ConstList.SHIFT) {
        this.attendance2.splice(index, 1, ConstList.SHIFT);
      }
      if (
        id1 === ConstList.PAID ||
        id1 === ConstList.SUBSTITUTE ||
        id1 === ConstList.SPECIAL_HOLIDAY ||
        id1 === ConstList.DEDUCTION ||
        id1 === ConstList.HOLIDAY
      ) {
        this.start.splice(index, 1, "");
        this.end.splice(index, 1, "");
        this.rest.splice(index, 1, "");
        this.nightRest.splice(index, 1, "");
      }
    },
    // 休憩時間操作
    autoRestTime(index) {
      const start = this.start[index];
      const end = this.end[index];
      if (!start || !end) {
        this.rest.splice(index, 1, null);
        return;
      }

      const rBasic = moment.duration(this.breakBasic[index], "HH:mm");
      const postBuffer = moment.duration(this.postBuffer[index] ?? "00:00", "HH:mm");
      const startTime = moment.duration(start, "HH:mm");
      const endTimeRaw = moment.duration(end, "HH:mm");

      // 日付またぎ補正（終了 <= 開始 の場合は翌日扱い）
      const endTime = endTimeRaw.clone();
      if (endTime.asMinutes() <= startTime.asMinutes()) {
        endTime.add(24, "hours");
      }

      let restTime = rBasic.clone();

      if (this.postWorkBreakFlg[index]) {
        // SHIFT のときだけ：会社規定 workBasic(例:08:00) を基準に「実働が超えた分」を見て追加休憩を付与
        if (this.attendance1[index] === ConstList.SHIFT) {
          const wb = moment.duration(this.workBasic[index] ?? "00:00", "HH:mm");
          const nightRest = moment.duration(this.nightRest?.[index] ?? "00:00", "HH:mm");

          // 追加休憩を付ける前の実働（開始〜終了−基本休憩−夜勤休憩）
          const workedMin = endTime.clone().subtract(startTime).subtract(rBasic).subtract(nightRest).asMinutes();
          const overtimeMin = workedMin - wb.asMinutes();

          if (overtimeMin > 0) {
            const addMin = Math.min(postBuffer.asMinutes(), overtimeMin);
            restTime.add(moment.duration(addMin, "minutes"));
          }
        } else {
          // 常勤等は影響を出さない
          const endBase = moment.duration(this.endBasic[index], "HH:mm");
          const diffMin = endTime.asMinutes() - endBase.asMinutes();
          if (diffMin >= postBuffer.asMinutes()) {
            restTime.add(postBuffer);
          } else if (diffMin > 0) {
            restTime.add(moment.duration(diffMin, "minutes"));
          }
        }
      }

      const h = String(restTime.hours()).padStart(2, "0");
      const m = String(restTime.minutes()).padStart(2, "0");
      this.rest.splice(index, 1, `${h}:${m}`);
    },
    applyRosterFileImport ({ rows, overwriteMode, fillRestFromSchedule }) {
      const hasValue = value => value !== null && value !== undefined && String(value) !== '';
      const applyValue = (target, index, value) => {
        if (value === undefined) return false;
        if (overwriteMode === 'empty' && hasValue(target[index])) return false;
        const current = target[index] == null ? '' : target[index];
        const next = value == null ? '' : value;
        if (String(current) === String(next)) return false;
        this.$set(target, index, value);
        return true;
      };

      let projectChanged = false;
      const touchedRows = [];
      (rows || []).forEach(row => {
        if (!row || !Number.isInteger(row.index) || row.index < 0 || row.index >= this.monthDay.length) return;
        const index = row.index;
        const values = row.values || {};
        let changed = false;

        const changedProject = applyValue(this.projectId, index, values.projectId);
        projectChanged = changedProject || projectChanged;
        changed = changedProject || changed;
        changed = applyValue(this.start, index, values.start) || changed;
        changed = applyValue(this.end, index, values.end) || changed;
        changed = applyValue(this.rest, index, values.rest) || changed;
        changed = applyValue(this.nightRest, index, values.nightRest) || changed;
        changed = applyValue(this.attendance1, index, values.attendance1) || changed;
        changed = applyValue(this.attendance2, index, values.attendance2) || changed;
        changed = applyValue(this.remarks, index, values.remarks) || changed;

        if (changed || row.autoFillRest) {
          touchedRows.push({ index, autoFillRest: Boolean(row.autoFillRest) });
        }
      });

      const finalize = () => {
        touchedRows.forEach(row => {
          this.autoTime(row.index);
          if (
            fillRestFromSchedule &&
            row.autoFillRest &&
            this.start[row.index] &&
            this.end[row.index] &&
            !this.rest[row.index]
          ) {
            this.autoRestTime(row.index);
          }
        });
        this.$nextTick(() => this.$forceUpdate());
      };

      if (projectChanged) {
        this.hydrateDailyBasicsByProject()
          .then(finalize)
          .catch(() => {
            alert('プロジェクト設定を取得できませんでした。画面を再表示してから、もう一度取り込んでください。');
          });
      } else {
        finalize();
      }
    },
    autoFillDefaultTimes(i) {
      return this.applyDefaultAt(i);
    },
    formatDurationToHHMM(duration) {
      const hours = Math.abs(duration.hours()) < 10 ? "0" + Math.abs(duration.hours()) : Math.abs(duration.hours());
      const minutes = Math.abs(duration.minutes()) < 10 ? "0" + Math.abs(duration.minutes()) : Math.abs(duration.minutes());
      return (duration.asMinutes() < 0 ? "-" : "") + hours + ":" + minutes;
    },
    // 表示用のラベル変換
    getStatusLabel(status) {
      if (!status) {
        return ConstList.UNSUBMITTED; // '未申請'
      }
      return status;
    },
    // 承認状態の識別
    statusColor(status) {
      const label = this.getStatusLabel(status);
      switch (label) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED:
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    // プロジェクトID配列から日別の基準を流し込む（Promise版）
    hydrateDailyBasicsByProject() {
      const ids = Array.from(new Set(this.projectId.filter(v => v != null)));
      if (!ids.length) return Promise.resolve(); // 呼び出し元のthenチェーンを壊さない

      return axios
        .get(process.env.VUE_APP_API_ORIGIN + "/project-basics", {
          params: { ids: ids.join(",") }
        })
        .then(({ data }) => {
          // 例：data = { "101": {...}, "102": {...} }
          this.projectId.forEach((pid, i) => {
            const p = data[String(pid)];
            if (!p) return;
            this.$set(this.startBasic, i, p.start ?? "");
            this.$set(this.endBasic,   i, p.end ?? "");
            this.$set(this.breakBasic, i, p.break ?? "");
            this.$set(this.preBuffer,  i, p.preBuffer ?? "00:00");
            this.$set(this.postBuffer, i, p.postBuffer ?? "00:00");
            this.$set(this.workTimeUnit, i, p.workTimeUnit ?? "00:00");
            this.$set(this.workBasic,    i, p.workBasic ?? "00:00");
            this.$set(this.postWorkBreakFlg, i, !!p.postWorkBreakFlg);
          });
          // 参照替えで子コンポーネント再計算
          this.startBasic = [...this.startBasic];
          this.endBasic   = [...this.endBasic];
          this.breakBasic = [...this.breakBasic];
          this.preBuffer  = [...this.preBuffer];
          this.postBuffer = [...this.postBuffer];
          this.workTimeUnit = [...this.workTimeUnit];
          this.workBasic    = [...this.workBasic];
          this.postWorkBreakFlg = [...this.postWorkBreakFlg];
        })
        .catch((e) => {
          axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(e) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => alert(ConstList.SYSTEM_ERROR))
            .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
        });
    },

    // プロジェクト選択変更時（Promise版）
    onChangeProject(index) {
      const pid = this.projectId[index];
      if (pid == null) return;

      return axios
        .get(process.env.VUE_APP_API_ORIGIN + "/project-basic", {
          params: { projectId: pid }
        })
        .then(({ data: p }) => {
          this.$set(this.startBasic, index, p.start ?? "");
          this.$set(this.endBasic,   index, p.end ?? "");
          this.$set(this.breakBasic, index, p.break ?? "");
          this.$set(this.preBuffer,  index, p.preBuffer ?? "00:00");
          this.$set(this.postBuffer, index, p.postBuffer ?? "00:00");
          this.$set(this.workTimeUnit, index, p.workTimeUnit ?? "00:00");
          this.$set(this.workBasic,    index, p.workBasic ?? "00:00");
          this.$set(this.postWorkBreakFlg, index, !!p.postWorkBreakFlg);

          // 直ちに休憩再計算（postWorkBreakFlg / endBasic の影響を反映）
          this.autoRestTime(index);

          // 参照替えで子を再計算
          this.startBasic = [...this.startBasic];
          this.endBasic   = [...this.endBasic];
          this.breakBasic = [...this.breakBasic];
          this.preBuffer  = [...this.preBuffer];
          this.postBuffer = [...this.postBuffer];
          this.workTimeUnit = [...this.workTimeUnit];
          this.workBasic    = [...this.workBasic];
          this.postWorkBreakFlg = [...this.postWorkBreakFlg];
        })
        .catch((e) => {
          axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(e) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => alert(ConstList.SYSTEM_ERROR))
            .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
        });
    },
    applyBulkProject() {
      if (!this.bulkProjectId) return; // 空は処理しない

      this.bulkApplying = true;
      const pid = this.bulkProjectId;
      this.projectId = this.projectId.map(() => pid);

      const done = () => {
        this.bulkApplying = false;
        this.bulkProjectId = "";
      };

      if (this.hydrateDailyBasicsByProject) {
        const r = this.hydrateDailyBasicsByProject();
        if (r && typeof r.then === "function") {
          r.then(done).catch(done);
        } else {
          done();
        }
      } else {
        done();
      }
    },
    openAttendanceHelp(kind) {
      this.attendanceHelpKind = kind;
      this.attendanceHelpOpen = true;
    },
    openAttendance1Help() { this.openAttendanceHelp("1"); },
    openAttendance2Help() { this.openAttendanceHelp("2"); },
    closeAttendanceHelp() {
  this.attendanceHelpOpen = false;
},

  },
  computed: {
    // 勤務時間の自動計算
    dailyWorkResult() {
      const result = [];
      for (let i = 0; i < this.start.length; i++) {
        const s = moment.duration(this.start[i], "HH:mm");
        const e = moment.duration(this.end[i], "HH:mm");
        const restDuration = moment.duration(this.rest[i] || "00:00", "HH:mm");
        const nightRestDuration = moment.duration(this.nightRest?.[i] ?? "00:00", "HH:mm");

        let actualStart = s.clone();
        const startBasicTime = moment.duration(this.startBasic[i], "HH:mm");

        // 入力が揃っていない日は null
        if (!this.start[i] || !this.end[i]) {
          result.push(null);
          continue;
        }

        // 始業時刻補正（遅刻除外）
        if (
          this.attendance1[i] === ConstList.FULLTIME ||
          this.attendance1[i] === ConstList.MORNING_WORK
        ) {
          const preBuffer = moment.duration(this.preBuffer[i] ?? "00:00", "HH:mm");
          const preBufferStart = startBasicTime.clone().subtract(preBuffer);

          if (
            actualStart.asMinutes() >= preBufferStart.asMinutes() &&
            actualStart.asMinutes() < startBasicTime.asMinutes()
          ) {
            actualStart = startBasicTime;
          }
        }

        // 終了時刻の補正（00:00 の場合は翌日扱い）
        let actualEnd = e.clone();
        if (actualEnd.asMinutes() <= actualStart.asMinutes()) {
          actualEnd = actualEnd.add(24, "hours");
        }

        // 勤務時間計算
        let workDuration = actualEnd.clone().subtract(actualStart).subtract(restDuration).subtract(nightRestDuration);

        result.push(this.formatDurationToHHMM(workDuration));
      }

      return [...result];
    },

    // 勤怠の入力制御
    afternoon: function () {
      const afternoon = this.devide;
      const list = this.attendance2;
      for (let i = 0; i < this.attendance1.length; i++) {
        if (
          this.attendance1[i] === ConstList.MORNING_WORK ||
          this.attendance1[i] === ConstList.MORNING_PAID ||
          this.attendance1[i] === ConstList.MORNING_SUBSTITUTE ||
          this.attendance1[i] === ConstList.MORNING_DEDUCTION ||
          this.attendance1[i] === ConstList.MORNING_SPECIAL_HOLIDAY ||
          this.attendance1[i] === ConstList.EARLY_MORNING ||
          this.attendance1[i] === ConstList.SHIFT
        ) {
          afternoon.splice(i, 1, false);
        } else {
          list.splice(i, 1, "");
          afternoon.splice(i, 1, true);
        }
      }
      return afternoon;
    },
    /*
     * 半日単位の休暇を使うか。**行ごとに同じ値が載ってくる**ので
     * 先頭を見る。読めないときは「使う」——いま使っている会社の
     * 選択肢を、通信の失敗で黙って消さない。
     */
    usesHalfDayLeave: function () {
      const row = this.items && this.items.length ? this.items[0] : null;
      return !row || row.half_day_leave_flg !== false;
    },
    // 勤怠2のバリデーション条件
    select: function () {
      let disable = this.id2_disable;
      for (let i = 0; i < this.attendance1.length; i++) {
        if (
          this.attendance1[i] === ConstList.MORNING_WORK ||
          this.attendance1[i] === ConstList.MORNING_PAID ||
          this.attendance1[i] === ConstList.MORNING_SUBSTITUTE ||
          this.attendance1[i] === ConstList.MORNING_DEDUCTION ||
          this.attendance1[i] === ConstList.MORNING_SPECIAL_HOLIDAY ||
          this.attendance1[i] === ConstList.EARLY_MORNING
        ) {
          disable = true;
        } else {
          disable = false;
        }
      }
      return disable;
    },
    // 送信用の開始時間の配列作成
    sendStart: function () {
      let sendS = this.start_time;
      for (let i = 0; i < this.start.length; i++) {
        const sTime = this.start[i] || "09:00";
        sendS.splice(i, 1, sTime + ":00");
      }
      return sendS;
    },
    // 送信用の終了時間の配列作成
    sendEnd: function () {
      let sendE = this.end_time;
      for (let i = 0; i < this.end.length; i++) {
        const eTime = this.end[i] || "18:00";
        sendE.splice(i, 1, eTime + ":00");
      }
      return sendE;
    },
    // 送信用の休憩時間の配列作成
    sendBreak: function () {
      let sendB = this.break_time;
      for (let i = 0; i < this.rest.length; i++) {
        const bTime = this.rest[i] || "01:00";
        sendB.splice(i, 1, bTime + ":00");
      }
      return sendB;
    },
    // 登録・更新ボタンの活性非活性
    activeButton: function () {
      const start = this.start;
      const end = this.end;
      const rest = this.rest;
      const id1 = this.attendance1;
      const remarks = this.remarks;
      if (
        start[0] !== "" &&
        end[0] !== "" &&
        rest[0] !== "" &&
        id1[0] !== 0 &&
        remarks[0] !== ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    // 終了時刻が0時を過ぎた場合の数値調整
    endSetting: function () {
      let setting = this.send_end;
      for (let i = 0; i < this.end.length; i++) {
        if (this.end[i] === "" || this.end[i] === null) {
          // null または空文字の場合に null を代入する
          setting.splice(i, 1, null);
        } else {
          let start = moment.duration(this.start[i], "HH:mm");
          let end = moment.duration(this.end[i], "HH:mm");
          let hour = 0;
          let minute = 0;
          if (end.hours() < start.hours()) {
            hour = end.hours() + 24;
            minute = end.minutes();
            const hours = hour < 10 ? "0" + hour : hour;
            const minutes = minute < 10 ? "0" + minute : minute;
            const time = hours + ":" + minutes;
            setting.splice(i, 1, time);
          } else {
            const hours = end.hours() < 10 ? "0" + end.hours() : end.hours();
            const minutes =
              end.minutes() < 10 ? "0" + end.minutes() : end.minutes();
            const time = hours + ":" + minutes;
            setting.splice(i, 1, time);
          }
        }
      }
      return 0;
    },
    globalLoading() {
      return this.loading || this.bulkApplying;
    },
  },
  mounted() {
    if (this.fromExternal) {
      // 管理者が対象ユーザーを表示する場合（Info.vue 経由）
      this.user_id = this.externalUserId;
      this.year = this.externalYear;
      this.month = this.externalMonth;
      this.user_name = this.externalUserName;
      this.callList(); // ← 外から渡されたユーザで初回表示
    } else {
      // 一般ユーザーの場合（ログインユーザー自身）
      const today = moment();
      if (today.date() < 10) {
        today.subtract(1, "months");
      }
      this.year = Number(today.format("YYYY"));
      this.month = Number(today.format("M"));
      const context = getCachedAccessContext();
      this.user_id = context && context.userId ? context.userId : "";
      this.user_name = "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}

button:disabled {
  cursor: not-allowed;
}

.dayHeader { white-space: pre; }  /* <br> だけで改行。自動折返しなし */
.dayLabel  { white-space: pre; }  /* \n だけで改行。自動折返しなし */

.roster-guide-grid {
  display: grid;
  margin: 0 25px 24px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: 20px;
}

.roster-guide-grid > .roster-guide-card,
.roster-guide-grid > .roster-guide-card + .roster-guide-card {
  display: flex;
  width: 100%;
  min-width: 0;
  min-height: 300px;
  flex-direction: column;
  margin: 0 !important;
  overflow: hidden;
}

.roster-guide-card__header {
  display: flex !important;
  min-height: 76px !important;
  align-items: center !important;
  padding: 20px 28px !important;
  border-bottom: 1px solid rgba(255, 255, 255, .18) !important;
  background: rgba(255, 255, 255, .08) !important;
  color: inherit !important;
  gap: 12px;
}

.roster-guide-card__header::before,
.roster-guide-card__header::after {
  content: none !important;
}

.roster-guide-card__header strong {
  color: inherit !important;
  font-size: 20px !important;
  font-weight: 800 !important;
}

.roster-guide-card__badge {
  margin-left: auto;
  font-size: 12px;
  white-space: nowrap;
}

.roster-guide-card__body {
  flex: 1 1 auto;
  padding: 24px 28px !important;
  color: inherit;
  font-size: 15px;
  line-height: 1.85;
}

.roster-guide-file {
  display: block;
  width: min(100%, 320px);
  min-width: 0;
}

.roster-actual-guide {
  /*
    **縦に積む。**以前は space-between で右端へ飛ばしていた。
    画面が広いほど説明から離れ、読み終わった視線の先に無い。
  */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 16px;
  padding: 14px 16px;
  border: 1px solid #cfe2f2;
  border-radius: 12px;
  background: #f5faff;
}
.roster-actual-guide strong { color: #164e75; }
.roster-actual-guide p { margin: 0; color: #60788a; font-size: 12px; }
/* **押すものだと分かる色にする。**枠だけだと周りの白い枠に紛れる。
   誤って押しても、applyDefaultsToPast が確認の幕を出して止まる。 */
/* **左端を見出しへ揃える。**素の button に margin: 1em が当たっていて、
   縦に積んだ瞬間に 11px ずれた。右端に置いていたときは目立たなかった。 */
.roster-actual-guide__action { flex: 0 0 auto; margin: 0; }
.roster-time-candidate {
  display: block;
  margin-top: -1px;
  color: #70899a;
  font-size: 9px;
  line-height: 1.35;
}

/*
  入力の誤りを、欄のすぐ下に出す。

  **上にまとめて出さない。**31行ある表で「どこかが赤い」とだけ
  言われても探せない。前の RosterError がその形で、しかも中身が
  全部コメントアウトされていて1行も出なかった。
*/
.roster-field-error {
  display: block;
  margin: 1px 0 0;
  color: #c0392b;
  font-size: 10px;
  line-height: 1.3;
  white-space: nowrap;
}
.roster-row-state {
  display: block;
  margin-top: 5px;
  color: #7f91a0;
  font-size: 10px;
  font-weight: 700;
}
.roster-default-button {
  margin-top: 5px;
  padding: 3px 6px;
  border: 1px solid #88bfe3;
  border-radius: 7px;
  background: #fff;
  color: #12679e;
  font-size: 9px;
  font-weight: 700;
}
@media (max-width: 991.98px) {
  .roster-guide-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 767.98px) {
  .roster-guide-grid {
    margin-right: 14px;
    margin-left: 14px;
  }

  /* 狭い画面では横いっぱいに。並び自体は既に縦。 */
  .roster-actual-guide__action { width: 100%; }
}

</style>
